import { useEffect, useRef, useState, lazy } from "react";
import { InView } from "react-intersection-observer";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

import StoreSkelton from "../../components/Home/StoreSkelton";
// const MobileMenuPopup=lazy(()=>import( "../../components/Menu/MobileMenuPopup"))
import MobileMenuPopup from "../../components/Menu/MobileMenuPopup";
import MobileMenu from "../../components/Menu/MobileMenu";
import Header from "../../components/Header/Header";
// import KitchenCard from "../../components/Home/KitchenCard";
import KitchenCard from "../../components/Home/kitchecnCard/KitchenCard3";
import MenuCard from "../../components/Menu/MenuCard";
import HamburgerMenu from "../../components/Sidebar/HamburgerMenu";
import Sidebar from "../../components/Sidebar/Sidebar";
import FeaturedItems from "../../components/Home/FeaturedItems";
import AddressMap from "../../components/Home/AddressMap";
import ChangeStoreComponent from "../../components/StoreChange/ChangeStoreComponent";
import NoDataFound from "../../components/NoDataFound/NoDataFound";
import Suspence from "../../components/Suspence/Suspence";
import { SETSELECTEDCATEGORY } from "../../redux/features/categoryList";
import useSelectedStore from "../../hooks/useSelectedStore";
import IndivisualQuantity from "../../utils/IndivisualQuantity";

import { getCookie, getFeaturedItemList } from "../../utils/helper";
import ParseFloat from "../../utils/ParseFloat";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import LanguageApi from "../../api/languageApi";
import useDeviceIos from "../../hooks/useDeviceIos";
import useMobile from "../../hooks/useMobile";
import { SETCARTOPENSTATUS } from "../../redux/features/CartData";
import { getItemNames } from "../../utils/GetItemsName";
import Konsole from "../../utils/konsole/Konsole";
import useReduxData from "../../hooks/useReduxData";
import NoItemsFound from "../../components/NoDataFound/NoItemsFound";
import useAllApiCall from "../../hooks/useAllApiCall";
import StoreBanner from "../../components/Home/kitchecnCard/StoreBanner";

export default function Menu() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const redux_data = useReduxData();
  const { getStoreInfo, isStoreDataFetched } = useAllApiCall();
  const { isStoreSelected } = useSelectedStore();
  const location = useLocation();
  // console.log("_location", redux_data?.store?.selectedStore);

  const { isShowStoreNameHeader, isShowMobileSearch } = redux_data.commonData;
  const [menuOpen, setMenuOpen] = useState(false);
  // const [showCart, setShowCart] = useState(false);
  const [sidebar, setSidebar] = useState(false);
  const [loading, setLoading] = useState(false);
  const [lang, setLang] = useState(i18next.language);
  const [storeId, setStoreId] = useState(null);
  const { t } = useTranslation();
  const [checkOpen, setCheckOpen] = useState(false);
  const iosDevice = useDeviceIos();
  const mobile = useMobile();

  Konsole.log("Konsole", sidebar);

  const handleMenuOpen = () => {
    setMenuOpen(!menuOpen);
  };

  const handleSidebar = () => {
    setSidebar(!sidebar);
  };
  // const handleShowCart = () => {
  //   setShowCart(!showCart);
  // };

  const {
    filterData: { search, filterCategory },
    cartData: { itemCount, items, totalPrice, isCartOpen },
    store: { allCategory, selectedStore, allStore },
    languageData: { translations },
  }: any = useSelector((state: any) => state);

  useEffect(() => {
    if (!translations[lang] || Object.keys(translations[lang])?.length === 0) {
      if (storeId) {
        LanguageApi(dispatch, storeId);
      }
    }
  }, [storeId]);

  useEffect(() => {
    let res = getCookie("user-data");
    if (res) {
      let resParse = JSON.parse(res);
      // console.log('resasdf', resParse, resParse?.email)
    }
    handleLoaded();
  }, []);
  const handleLoaded = () => {
    // Check if Google Maps API is already loaded
    if (!window.google) {
      const existingScript = document.querySelector(
        'script[src^="https://maps.googleapis.com/maps/api/js"]'
      );
      if (!existingScript) {
        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLEMAPS_API_KEY}&libraries=places`;
        script.async = true; // Ensures script loads asynchronously
        script.defer = true; // Ensures script doesn’t block other resources
        // script.onload = () => {
        //     setGoogleAPIReady(true);
        // };
        script.onerror = () => {
          console.error("Error loading Google Maps API");
        };
        document.body.appendChild(script);
      }
    }
  };

  useEffect(() => {
    sessionStorage.removeItem("store");
    sessionStorage.removeItem("items");
    sessionStorage.removeItem("backCheckout");
    sessionStorage.removeItem("domain_setting");

    // navigator.geolocation.getCurrentPosition(success, error);
    // function success(positions: any) {
    //   const search = {
    //     search_item: "",
    //     latitude: positions.coords.latitude,
    //     longitude: positions.coords.latitude,
    //   };
    //   console.log("_searchsearch", search, positions);
    //   if (search.latitude && search.longitude) {
    //     getDataOfStore(search);
    //   }
    //   setLoading(false);
    //   sessionStorage.setItem("longitude", positions.coords.longitude);
    //   sessionStorage.setItem("latitude", positions.coords.latitude);
    // }
    // function error(err: any) {
    //   console.log("err", err);
    //   sessionStorage.removeItem("longitude");
    //   sessionStorage.removeItem("latitude");
    //   sessionStorage.removeItem("store");
    //   sessionStorage.removeItem("items");
    //   sessionStorage.removeItem("backCheckout");
    //   sessionStorage.removeItem("domain_setting");
    //   getDataOfStore();
    // }
    sessionStorage.removeItem("longitude");
    sessionStorage.removeItem("latitude");
    sessionStorage.removeItem("store");
    sessionStorage.removeItem("items");
    sessionStorage.removeItem("backCheckout");
    sessionStorage.removeItem("domain_setting");
    getDataOfStore()
  }, []);

  // @@ store name display on header ehen scrolling
  const scrollRef = useRef<HTMLDivElement>(null);
  const stickyRef = useRef<any>(null);



  const getDataOfStore = (info?: any) => {
    getStoreInfo(info || "");
  };

  if (loading || !isStoreDataFetched) {
    return <Suspence />;
  }

  const setInView = (inView: any, entry: any) => {
    let isSidebarClicking = sessionStorage.getItem("isSidebarClicking");
    // console.log("_isSidebarClicking",isSidebarClicking)
    if (inView) {
      if (isSidebarClicking == "true") {
        return;
      }
      dispatch(SETSELECTEDCATEGORY(entry.target.getAttribute("id")));

      // debouceFunction(entry.target.getAttribute("id"), dispatch);
      navigate(`?slug=${entry.target.getAttribute("id")}`);
    }
  };

  function BackgroundTemplate(value: any) {
    if (value?.banner_image?.base_url) {
      return (
        selectedStore?.banner_image?.base_url +
        selectedStore?.banner_image?.attachment_url
      );
    }

    return "/public/images/bg.jpg";
  }

  // // @ return banner image
  // const bannerImageUrl = useMemo(() => {
  //   if (selectedStore) {
  //     return (
  //       selectedStore?.banner_image?.base_url +
  //       selectedStore?.banner_image?.attachment_url
  //     );
  //   }

  //   return "/public/images/bg.jpg";
  // }, [selectedStore]);

  // console.log("_bannerImageUrl", bannerImageUrl);
  // Konsole.log("allStoreallStore", items, allStore, allCategory);

  return (
    <>
      {/* <Seo /> */}

      <div className="topheader">
        <div className="pageHeader">
          <Header handleSidebar={handleSidebar} />
        </div>
      </div>

      {isStoreSelected ? (
        <>
          <div
            className={`${sidebar ? "left-0 profile-data" : "left-[-50rem]"
              } md:hidden block absolute h-screen w-screen transition-all z-[51] bg-white profile-data`}
          >
            <HamburgerMenu handleSidebar={handleSidebar} sidebar={sidebar} />
          </div>

          <div
            ref={scrollRef}
            className={`h-dvh overflow-y-auto scroll-hidden bg-[#fff] w-full pt-16 ${iosDevice && mobile ? "yumdel-bannerIOS" : "yumdel-banner"
              }  `}
            style={{
              // height: "100vh",                  // ensures full viewport height
              WebkitOverflowScrolling: "touch", // smooth scrolling for iOS
            }}
            id="bottom-to-top"
          >
            {/* {!isShowMobileSearch && (
              <div
                className="store-banner relative "
                style={{
                  backgroundImage: `url("${BackgroundTemplate(
                    selectedStore
                  )}")`,
                }}
              >
                <div className="delivery-outer absolute  md:top-[20rem] top-[7.75rem] md:left-2/4 md:translate-x-[-50%] md:translate-y-[-50%] md:px-10 container mx-auto">
                  <KitchenCard className="menu" />
                </div>
              </div>
            )} */}
            {!isShowMobileSearch && (
              <div
                className="md:pt-[30px]  md:px-10 px-3 container mx-auto mt-5 md:mt-0 mobile-margin-top" >
                <StoreBanner image={BackgroundTemplate(selectedStore)} />
                <KitchenCard className="menu" />
              </div>

            )}

{/* md:pt-[90px]  */}
            <div
              className="md:px-10  px-3 container mx-auto md:mt-0 mobile-margin-top"
              id="bottom-to-top-menu"
            >

              <AddressMap />
              <FeaturedItems />

              <div
                className="top-0 md:hidden block sticky z-[9] mb-2"
                ref={stickyRef}
              >
                {!isShowMobileSearch && <MobileMenu />}
              </div>

              <div className="flex gap-6" id="Display-Category-Items">
                <div className="sideBarWrapper sticky top-4 md:block hidden ">
                  <Sidebar />
                </div>
                {/* <button onClick={()=>setCheckOpen(true)} style={{ backgroundColor: 'red', height: "50px" }}>Check Modal</button> */}
                <div className="w-full mb-12 md:mb-0">
                  {loading ? (
                    <StoreSkelton />
                  ) : (search ? filterCategory : allCategory)?.length == 0 ? (
                    <>
                      <NoItemsFound />
                      {/* <NoDataFound content={t("MyOrders.noDataFound")} /> */}
                    </>
                  ) : (
                    (search ? filterCategory : allCategory)?.map(
                      (category: any, index: number) => {
                        return (
                          <InView
                            onChange={setInView}
                            threshold={0.2}
                            // threshold={[0, 0.25, 0.5, 0.75, 1]}
                            // threshold={0}
                            // triggerOnce={true}
                            key={index}
                            rootMargin="-150px 0px 0px 0px"
                          >
                            {({ ref: inViewRef }) => {
                              return (
                                <div
                                  key={index}
                                  id={category?.slug}
                                  ref={inViewRef}
                                >
                                  {category?.sub_category_data?.length > 0
                                    ? category?.sub_category_data?.map(
                                      (data: any) => {
                                        return data?.item_data?.length > 0 ? (
                                          <div
                                            key={data?.menu_id}
                                            className="catagory "
                                          >
                                            <p className="section-title mb-3 custom-heading-store-light  ">
                                              {/* {data?.name} */}
                                              {/* {translations?.[lang]?.[
                                              data?.name
                                            ] ||
                                              capitalizeFirstLetter(data?.name) } */}
                                              {getItemNames(
                                                data?.name,
                                                translations,
                                                lang
                                              )}
                                            </p>
                                            <div
                                              className={`${itemCount > 0
                                                ? " md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 "
                                                : " md:grid-cols-1  lg:grid-cols-2 xl:grid-cols-2"
                                                } cardWrapper grid grid-cols-1 sm:grid-cols-1 gap-2.5 mb-5 mb-gap-1rem`}
                                            >
                                              {data?.item_data?.length ==
                                                0 ? (
                                                <NoDataFound content="No Data Found" />
                                              ) : (
                                                data?.item_data?.map(
                                                  (item: any) => {
                                                    return (
                                                      <>
                                                        <MenuCard
                                                          refrencePage="menu"
                                                          key={item?.item_id}
                                                          classNameType={
                                                            item?.item_type ==
                                                              0
                                                              ? "Veg"
                                                              : "nonVeg"
                                                          }
                                                          item={item}
                                                          quantity={
                                                            IndivisualQuantity(
                                                              items,
                                                              item.item_id
                                                            ) || 0
                                                          }
                                                          menu_id={
                                                            data.menu_id
                                                          }
                                                          taxdata={data}
                                                        />
                                                        <hr className="md:hidden block" />
                                                      </>
                                                    );
                                                  }
                                                )
                                              )}
                                            </div>
                                          </div>
                                        ) : (
                                          ""
                                        );
                                      }
                                    )
                                    : ""}
                                </div>
                              );
                            }}
                          </InView>
                        );
                      }
                    )
                  )}
                </div>
              </div>
            </div>
          </div>

          {itemCount > 0 && isCartOpen == false && (
            <span
              // to="/checkout"
              onClick={() => dispatch(SETCARTOPENSTATUS(!isCartOpen))}
              className=" p-3 text-center fixed w-full bottom-0 md:hidden block view-cart-button"
            >
              <div className="bgBlue text-white p-3 rounded-lg flex justify-between text-base font-bold">
                <div className="flex gap-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M4.51009 1.66504L1.66829 1.67806L1.67643 3.34473L3.40169 3.33659L4.09505 5H5.19531V5.00163H16.0807L13.7663 9.16829H7.75391V9.16667H6.74316L5.26693 11.5218C4.93359 12.0551 4.91635 12.7288 5.22135 13.278C5.52635 13.8272 6.10506 14.1683 6.7334 14.1683H16.665V12.5016H6.7334L6.67969 12.404L7.66113 10.835H13.7663C14.3721 10.835 14.9296 10.5055 15.223 9.97721L18.2259 4.57194C18.3701 4.31361 18.3661 4.00012 18.2161 3.74512C18.0661 3.49095 17.7917 3.33496 17.4967 3.33496H5.20671L4.51009 1.66504ZM0 6.66667V8.33333H5.29948L5.33366 8.28288L6.34928 6.66667H0ZM0 10V11.6667H3.19987L4.25781 10H0ZM6.66504 15.0016C6.22301 15.0016 5.79909 15.1772 5.48653 15.4898C5.17397 15.8023 4.99837 16.2263 4.99837 16.6683C4.99837 17.1103 5.17397 17.5342 5.48653 17.8468C5.79909 18.1594 6.22301 18.335 6.66504 18.335C7.10707 18.335 7.53099 18.1594 7.84355 17.8468C8.15611 17.5342 8.33171 17.1103 8.33171 16.6683C8.33171 16.2263 8.15611 15.8023 7.84355 15.4898C7.53099 15.1772 7.10707 15.0016 6.66504 15.0016ZM14.9984 15.0016C14.5563 15.0016 14.1324 15.1772 13.8199 15.4898C13.5073 15.8023 13.3317 16.2263 13.3317 16.6683C13.3317 17.1103 13.5073 17.5342 13.8199 17.8468C14.1324 18.1594 14.5563 18.335 14.9984 18.335C15.4404 18.335 15.8643 18.1594 16.1769 17.8468C16.4894 17.5342 16.665 17.1103 16.665 16.6683C16.665 16.2263 16.4894 15.8023 16.1769 15.4898C15.8643 15.1772 15.4404 15.0016 14.9984 15.0016Z"
                      fill="white"
                    />
                  </svg>
                  {t("Home.viewCart")}
                </div>
                {ParseFloat(totalPrice || 0)} {" | "} {itemCount || 0}{" "}
                {itemCount > 1 ? t("CartDetails.items") : t("CartDetails.item")}
              </div>
            </span>
          )}

          {menuOpen && (
            <>
              <MobileMenuPopup
                menuOpen={menuOpen}
                onCloseModal={handleMenuOpen}
              />
              <div className="bg-black opacity-15 h-screen absolute top-0 w-screen z-[49]"></div>
            </>
          )}
        </>
      ) : (
        <ChangeStoreComponent />
      )}
    </>
  );
}
